export default __webpack_public_path__ + "static/media/icons8-node-js.98ddef9b.svg";